module.exports = __webpack_public_path__ + "img/xjtu+.d106ea7d.jpg";